import isExpired from "./isExpired.js";

const reqOptions = (method, body, needToken = true, formData) => {
	const headers = {};
	const options = {
		method,
		headers,
	};
	if (needToken) {
		const token = localStorage.getItem("token");
		headers.Authentication = token;
		if (isExpired(token) || !token) {
			localStorage.removeItem("token");
			window.location.replace("/ticketing/Signin");
			return false;
		}
	}
	if (method !== "GET" && formData) {
		options.body = body;
	}

	if (method !== "GET" && !formData) {
		headers["Content-Type"] = "application/json";
		options.body = JSON.stringify(body);
	}
	return options;
};

export default reqOptions;
